<companyid-content-wrapper classNames="flex-col w-full py-80px gap-40px px-5">
    <companyid-title-and-subtitle
        [title]="title()"
        [subtitle]="subtitle()"
        class="!gap-5px mob:text-center tab:text-center !text-medium-regular"
    />
    <div class="flex desk:gap-x-40px w-full mob:flex-col tab:flex-col tab:gap-40px mob:gap-40px">
        <div class="flex tab:justify-center">
            <img [ngSrc]="'location' | asset: 'shared/location' : 'webp'" width="669" height="392" alt="location" />
        </div>
        <div class="flex flex-col mob:gap-40px tab:gap-40px">
            <div class="flex flex-col gap-25px">
                <span class="uppercase text-primary-color text-medium-medium tracking-1.5" i18n>Location</span>
                <companyid-locales class="gap-y-25px" />
            </div>
            <div class="mt-auto mob:mt-15px w-fit tab:w-full mob:w-full">
                <a i18n="@@button-contact-us" class="button-primary" routerLink="/contact-us"> Contact Us </a>
            </div>
        </div>
    </div>
</companyid-content-wrapper>
